import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

export const DASHBOARD_GADGETS_DOC = 'dashboardGadgets';
export const CURRENT_GADGETS_VERSION = 'v1';

const remindersConverter = {
  toFirestore(reminders: DashboardGadget): firebase.firestore.DocumentData {
    return withoutNulls({ ...reminders });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): DashboardGadget {
    const data = snapshot.data(options);
    return data as DashboardGadget;
  },
};

const getDashboardGadgetsRef = ({
  accountId,
  db,
  versionOverride,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
  versionOverride?: string;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.VISUALISATIONS_COLLECTION)
    .doc(DASHBOARD_GADGETS_DOC)
    .collection(versionOverride ? versionOverride : CURRENT_GADGETS_VERSION)
    .withConverter(remindersConverter);
};

export default getDashboardGadgetsRef;
